'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBizError = exports.isRequestError = exports.log = exports.createValueAssignReducer = exports.delay = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // 暴露给用户的 util 函数统一在这里聚合


var _deprecate = require('./utils/deprecate');

var _deprecate2 = _interopRequireDefault(_deprecate);

var _debug = require('./utils/debug');

var _type = require('./utils/type');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var delay = exports.delay = function delay(thresold) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, thresold);
  });
};

var createValueAssignReducer = exports.createValueAssignReducer = (0, _deprecate2.default)('"createValueAssignReducer" has been deprecated, try to use `module/setValues` instead')(function (key) {
  return function (state, _ref) {
    var payload = _ref.payload;

    var oldVal = state[key];
    if (oldVal !== payload) {
      return _extends({}, state, _defineProperty({}, key, payload));
    }

    return state;
  };
});

var log = exports.log = _debug.log;

var isRequestError = exports.isRequestError = function isRequestError(error) {
  if (!error instanceof Error) {
    return false;
  }

  return error.res && _type.is.num(error.res.status);
};

var isBizError = exports.isBizError = function isBizError(error) {
  return error.isBizError;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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